import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import ErrorBoundary from "@/components/ErrorBoundary";
import LanguageProvider, { useLanguage } from "@/lib/language";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Intro from "@/components/Intro";
import SpaceSection from "@/components/SpaceSection";
import MapSection from "@/components/MapSection";
import Footer from "@/components/Footer";

const PageContent = () => {
  const { t } = useLanguage();
  return (
    <div className="bg-cream text-ink antialiased">
      <Navigation />
      <main>
        <Hero />
        <Marquee />
        <Intro />
        {t.spaces.map((space, i) => (
          <SpaceSection key={space.id} space={space} index={i} />
        ))}
        <MapSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.5,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <LanguageProvider>
        <PageContent />
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
